import { cva } from 'class-variance-authority';

export const textVariants = cva('', {
  variants: {
    size: {
      small: 'eye:body-m eye:pr-2xs eye:text-left',
      default: 'eye:headline-m eye:absolute eye:text-center',
      big: 'eye:numbers-l eye:absolute eye:text-center',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
